import type React from 'react'
import Icon from '../../common/Icon'
import Spinner from '@/components/common/Spinner.tsx'
import type { MediaFolder } from '@/features/media-file/domain/models/media-folder.ts'

interface MediaFileFolderProps {
  folder: MediaFolder
  isLoading?: boolean
  onClick: () => void
  isFolderUp?: true
}
export const MediaFileFolder: React.FC<MediaFileFolderProps> = ({
  folder,
  isLoading,
  onClick,
  isFolderUp,
}) => {
  return (
    <div
      onClick={onClick}
      className="inline-flex h-14 w-full cursor-pointer items-center justify-center gap-2 border-b border-neutral-600 p-4"
    >
      <div className="flex h-6 w-6 items-center justify-center">
        {isLoading ? (
          <Spinner className="h-5 w-5" />
        ) : isFolderUp ? (
          <Icon name="folderUp" />
        ) : (
          <Icon name="folder" />
        )}
      </div>
      <div className="shrink grow basis-0 text-sm font-normal leading-tight text-white">
        {folder.name}
      </div>
      {isFolderUp ? (
        <Icon name="arrowUp" width={16} height={16} />
      ) : (
        <Icon name="chevronRight" width={16} height={16} />
      )}
    </div>
  )
}
